export default __webpack_public_path__ + "static/thumb-training-1631c67f567bf41f2a3d00efbf1860ed.jpg";